import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import Pagination from "../../../Kryzen Alpha App/Components/layouts/pagination";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import LeavesTrackingTable from "./Employee Leave Management/leaves_table";
import { useSelector } from "react-redux";
import { BsCalendar2XFill } from "react-icons/bs";
import { FcCalendar, FcRules } from "react-icons/fc";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";

const EmployeeLeaveManagement = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [leadOwner, setLeadOwner] = useState();
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    employee: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const store = useSelector((store) => store.login.user);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", getFilteredURL("/leave/getleaves/", page, filters))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);

          setTotalPages(Math.ceil(res.data?.leaveApplied / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const filteredData =
    store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
    store.Role === process.env.REACT_APP_ROLE_ADMIN ||
    store.Role === process.env.REACT_APP_ROLE_HR
      ? data?.leave
      : data?.leave?.filter((item) => item.userId == store.UserId);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center mb-3">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> Leaves Tracking
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Apply, modify and track your leaves.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/employee-leave-management/new-leave"}>
                    <button className="btn btn-primary d-none d-sm-block">
                      <BsCalendar2XFill className="me-2 fs-2" /> ADD NEW LEAVE
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search employee:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  employee: e.target.value,
                                })
                              }
                              value={filters.employee}
                            >
                              <option value="">select all</option>

                              {leadOwner &&
                                leadOwner?.map((state, index) => (
                                  <option key={index} value={state?.userName}>
                                    {state?.userName}
                                  </option>
                                ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      employee: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Search employee:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                employee: e.target.value,
                              })
                            }
                            value={filters.employee}
                          >
                            <option value="">select all</option>

                            {leadOwner &&
                              leadOwner?.map((state, index) => (
                                <option key={index} value={state?.userName}>
                                  {state?.userName}
                                </option>
                              ))}
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    employee: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card  mt-2">
                <div
                  className=""
                  style={{
                    backgroundColor: "rgb(100, 149, 237, 0.12)",
                  }}
                >
                  <div className="card-header">
                    <h3 className="card-title">
                      <FcRules className="fs-2 me-1" /> Leave Policy
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul>
                      <li className="m-1">
                        When you are in probation or in notice period; all
                        leaves will be unpaid.
                      </li>
                      <li className="m-1">
                        All confirmed employees are entitled to a total of 15
                        leaves per calendar year devided in quarters as
                        Q1:3leaves, Q2:4leaves, Q3:4leaves, Q4:4leaves.
                      </li>
                      {/* <li className="m-1">
                                                Leave allocation is structured on a quarterly
                                                basis as
                                                <ul>
                                                  <li>1st Quarter :- 3 leaves</li>
                                                  <li>2nd Quarter :- 4 leaves</li>
                                                  <li>3rd Quarter :- 4 leaves</li>
                                                  <li>4th Quarter :- 4 leaves</li>
                                                </ul>
                                              </li> */}
                      <li className="m-1">
                        You must submit a leave application at least 3 days in
                        advance for planned leaves using leave management
                        system.
                      </li>
                      <li className="m-1">
                        Not utilising the leave management system will result in
                        deduction of additional one day of pay for total number
                        of leaves taken.
                      </li>
                      <li className="m-1">
                        Approval of leaves is subject to the discretion of the
                        higher authority and the department needs.
                      </li>
                      <li className="m-1">
                        You can choose to work on additional days in any
                        calendar year. And get comp-off against it.
                      </li>
                      <li className="m-1">
                        Comp off leaves are mandatory to apply in leave
                        management system.
                      </li>
                      <li className="m-1">
                        In a month you can not avail more then 3 comp-off
                        leaves.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {filteredData && (
                  <LeavesTrackingTable
                    EX={filteredData}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <a href={"/employee-leave-management/new-leave"}>
                    <button className="btn btn-primary d-lg-none d-md-none mt-3 mb-3">
                      <BsCalendar2XFill className="me-2 fs-2" />
                      ADD NEW LEAVE
                    </button>
                  </a>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={filteredData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EmployeeLeaveManagement;
